import { render, staticRenderFns } from "./popup-card.vue?vue&type=template&id=0af94923"
import script from "./popup-card.vue?vue&type=script&lang=js"
export * from "./popup-card.vue?vue&type=script&lang=js"
import style0 from "./popup-card.vue?vue&type=style&index=0&id=0af94923&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports